import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Commander_ENTJ_personality_header from '../../images/personality_types_details/analysts_Commander_ENTJ_personality_header.svg'
import analysts_Commander_ENTJ_workplace_habits from '../../images/personality_types_details/analysts_Commander_ENTJ_workplace_habits.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const entjs_at_work = () => {
    return (
        <Layout>
            <main class="q-td analyst commander">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/commander-entj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entjs-at-work" className="tab with-progress active">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header analyst commander">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={analysts_Commander_ENTJ_personality_header} class="scene" alt='loading...'/>
                    <div class="type-info">
                        <h1><span>Commander</span> Personality</h1>
                        <div class="code">ENTJ-A / ENTJ-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>



                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/commander-entj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-careers">Career Paths</Link></li>
                                <li className="active"><Link to="/personality-types/commander-entjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>Workplace Habits</h1>


                        <p>For people with the Commander personality type, the workplace is all but a natural habitat. Commanders’ efficiency and clear communication are valued, their leadership is admired, and their ability to simply get things done is unrivaled. That being said, some situations are more appropriate for Commanders than others – these qualities all point to a managerial or executive role, making any position of comparative powerlessness highly undesirable.</p>

                        <div class="description-pullout">Commander personality types are strident ones though, able to adapt themselves to just about any hierarchical relationship by doing what they do best: asserting their opinions, taking the initiative, and accomplishing feats that others thought impossible.</div>

                        <h2>Commander Subordinates</h2>

                        <p>Subordinate positions are challenging for Commanders, and it takes active management to ensure their satisfaction and engagement. Ever the high achievers, Commander subordinates set out to learn new skills and to seek out new challenges and responsibilities, eager to prove that nothing is impossible with a little hard work. If things get a little slow, Commander personalities may slip into periods of absentmindedness, but when they feel involved in the projects around them, they prove well organized and well prioritized.</p>

                        <p>Commanders hold themselves to very high standards, but a lot of what sets this tone is feedback from their environment – namely, criticism from their managers. Objective, rational statements about what is done right and what can be done better are helpful to Commanders, and far from resenting such criticisms, they appreciate them. Opportunities for growth keep people with the Commander personality type engaged and productive, and so long as their managers recognize this as their primary responsibility, it will be a fruitful and satisfying relationship.</p>

                        <h2>Commander Colleagues</h2>

                        <p>Among colleagues, Commanders are sociable and greatly enjoy sharing ideas and critiques in their frequent brainstorming sessions. Natural leaders that they are, Commanders tend to assert themselves into positions as representatives and project leads, considering their objectivity and charisma the perfect qualities for these roles. Commander personalities enjoy working with equals, but people must demonstrate that they are equals – anyone Commanders view as being less competent or driven will see only condescension and arrogance.</p>

                        <div class="scene">
                            <img alt="Commander (ENTJ) workplace habits" src={analysts_Commander_ENTJ_workplace_habits} alt="Commander (ENTJ) workplace habits" />
                        </div>

                        <p>Commanders are strong-willed, even dominant, and though they enjoy inspiring and tutoring others, the energy they bring to the process can seem overbearing. When these roles are reversed, Commanders’ mentors should bear in mind that their students are very rational and respect firm confidence – hand-holding, emotional appeals or wavering indecision will likely burn the bridge then and there. In a partnership, what is best is what is most effective, and time wasted sugarcoating reality is just that – time wasted.</p>

                        <h2>Commander Managers</h2>

                        <p>Commander managers are confident, charismatic communicators, and they communicate but one vision: to get the job done as efficiently as possible, and to the highest standard of quality. All else is subordinate to that objective, but the means by which Commanders achieve it cause others to adopt this cause as their own. Commanders are natural leaders, and their ability to formulate a strategy and to identify the strengths of each member of their teams, incorporating those abilities into their plans so that each individual fills a unique and important role, makes them able motivators.</p>

                        <p>But while these efforts boost morale and satisfaction among Commanders’ likeminded subordinates, they are still crafted to achieve that ultimate goal of timely and exceptional work. Those seen as inefficient by their Commander managers, or who demonstrate themselves to be lazy or to produce shoddy work will know in no uncertain terms of their failure to impress. The only way to recover is to comply, the only alternative is to find a new manager to impress, somewhere else.</p>

                        <div class="number">07</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/commander-entj-careers' className='next-feature'>
                            Career Paths
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/commander-entj-conclusion' className='next-feature'>
                            Conclusion
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default entjs_at_work
